import type { RootState } from '..';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { SortOrder } from '../../components/common/types';

export interface DocumentationTopBarState {
  searchText: string;
  sort?: {
    sortBy: string;
    sortOrder: SortOrder;
  };
}

const initialState: DocumentationTopBarState = {
  searchText: '',
  sort: {
    sortBy: 'label',
    sortOrder: SortOrder.ASC,
  },
};

export const documentationTopBarSlice = createSlice({
  name: 'documentationTopBar',
  initialState,
  reducers: {
    setTopBarSearchText: (state, action: PayloadAction<{ searchText: string }>) => {
      state.searchText = action.payload.searchText;
    },
    setTopBarSort: (
      state,
      action: PayloadAction<{ sort: { sortBy: string; sortOrder: SortOrder } }>,
    ) => {
      state.sort = action.payload.sort;
    },
    clearTopBarState: (state) => {
      state.searchText = '';
      state.sort = undefined;
    },
  },
});

export const { setTopBarSearchText, setTopBarSort, clearTopBarState } =
  documentationTopBarSlice.actions;

export const selectTopBarSearchText = (state: RootState) => state.documentationTopBar.searchText;
export const selectTopBarSort = (state: RootState) => state.documentationTopBar.sort;

export default documentationTopBarSlice.reducer;
